import React, { useEffect, useState, Children, cloneElement, isValidElement } from 'react';
import { LoginPage } from './LoginPage';
import { Loader2 } from 'lucide-react';
interface PasswordProtectedWrapperProps {
  children: React.ReactNode;
}
export const PasswordProtectedWrapper: React.FC<PasswordProtectedWrapperProps> = ({
  children
}) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [isLoadingData, setIsLoadingData] = useState(false);
  // Valid credentials
  const validEmail = 'amy@outcastventures.com';
  const validPassword = 'c@llan';
  useEffect(() => {
    // Check if user is already authenticated
    const authStatus = localStorage.getItem('bridge_auth');
    if (authStatus === 'authenticated') {
      setIsAuthenticated(true);
      // Simulate data loading when coming back to the app
      setIsLoadingData(true);
      setTimeout(() => {
        setIsLoadingData(false);
      }, 2500); // 2.5 seconds loading time
    }
    setIsLoading(false);
  }, []);
  const handleLogin = (email: string, password: string) => {
    if (email === validEmail && password === validPassword) {
      localStorage.setItem('bridge_auth', 'authenticated');
      setIsAuthenticated(true);
      // Start the loading sequence after successful login
      setIsLoadingData(true);
      setTimeout(() => {
        setIsLoadingData(false);
      }, 2500); // 2.5 seconds loading time
      return true;
    }
    return false;
  };
  const handleSignOut = () => {
    localStorage.removeItem('bridge_auth');
    setIsAuthenticated(false);
  };
  if (isLoading) {
    return <div className="flex items-center justify-center min-h-screen bg-[#0a0a0a] text-white" data-id="element-544">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-white" data-id="element-545"></div>
      </div>;
  }
  if (!isAuthenticated) {
    return <LoginPage onLogin={handleLogin} data-id="element-546" />;
  }
  if (isLoadingData) {
    return <div className="flex flex-col items-center justify-center min-h-screen bg-[#0a0a0a] text-white font-mono" data-id="element-547">
        <div className="w-full max-w-md p-8 space-y-8 flex flex-col items-center" data-id="element-548">
          <Loader2 size={48} className="animate-spin text-indigo-500 mb-4" data-id="element-549" />
          <h2 className="text-xl" data-id="element-550">Loading founder data...</h2>
          <div className="w-full bg-[#1a1a1a] h-2 rounded-full mt-4 overflow-hidden" data-id="element-551">
            <div className="bg-indigo-500 h-full animate-pulse" style={{
            width: '100%'
          }} data-id="element-552"></div>
          </div>
          <div className="text-xs text-gray-400 mt-4 text-center" data-id="element-553">
            <p data-id="element-554">Analyzing compatibility patterns</p>
            <p data-id="element-555">Processing network connections</p>
            <p data-id="element-556">Calculating velocity scores</p>
          </div>
        </div>
      </div>;
  }
  // Clone children and pass the signOut handler
  const childrenWithProps = Children.map(children, child => {
    if (isValidElement(child)) {
      return cloneElement(child, {
        onSignOut: handleSignOut
      } as any);
    }
    return child;
  });
  return <>{childrenWithProps}</>;
};